import { Card, DashboardSectionAction, DashboardSectionTitle, useArtifactCanvas } from '@yeshuman/sdk'
import { useCallback } from 'react'

import { useImproveCompleteness } from '../../hooks/use-improve'
import { ImproveReviewCanvas } from './improve-review-canvas'
import { ImproveMissingList, formatStrength } from './improve-missing-list'

/** Candidate home: profile gaps that hurt matching, with the reviewed repair entry. Hidden when complete. */
export function ProfileStrengthSection() {
  const { data } = useImproveCompleteness({ kind: 'profile' })
  const { openCanvas, closeCanvas } = useArtifactCanvas()

  const openReview = useCallback(() => {
    openCanvas({
      title: 'Improve my profile',
      preventAutoFocus: true,
      content: <ImproveReviewCanvas target={{ kind: 'profile' }} onClose={closeCanvas} />,
    })
  }, [closeCanvas, openCanvas])

  if (!data || data.ok) return null

  return (
    <section className="space-y-4" aria-labelledby="dashboard-profile-strength-heading">
      <DashboardSectionTitle
        id="dashboard-profile-strength-heading"
        title="Profile strength"
        action={<DashboardSectionAction onClick={openReview}>Improve my profile</DashboardSectionAction>}
      />
      <Card>
        <p className="text-sm">
          <span className="font-medium">{formatStrength(data.score)} complete.</span>{' '}
          <span className="text-muted-foreground">
            Employers match on these details, so gaps here lower your fit.
          </span>
        </p>
        <ImproveMissingList missing={data.missing} />
      </Card>
    </section>
  )
}
